import React, { createRef } from "react";
import { fieldValidation as validation } from "../utils/field-validation";
import fieldPropTypes from "./field-prop-types";
import ValidationMessage from "../theme/default/validation-message";

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.wrapperRef = createRef();
    this.updateControlValidation();
  }

  componentDidUpdate() {
    this.updateControlValidation();
  }

  updateControlValidation = () => {
    const { field, appData } = this.props;
    const isFieldVisible =
      !appData.assesmentsState[field.name] ||
      appData.assesmentsState[field.name].visible;
    if (isFieldVisible) {
      validation[field.type].update(field, appData, {
        fieldRef: this.wrapperRef
      });
    }
  };

  render() {
    const {
      field,
      appData,
      components: { Label, Slider: ThemeSlider }
    } = this.props;
    this.isRequired =
      this.props.appData.showAsterisk &&
      !this.props.field.params.includes("IsOptional");
    const {
      values,
      handleSliderChange,
      fieldValidation,
      resetFieldValidation
    } = appData;
    const isFieldVisible =
      !appData.assesmentsState[field.name] ||
      appData.assesmentsState[field.name].visible;
    const { name, title, params, accessibility = {} } = field;
    const invalid = fieldValidation[name] && !fieldValidation[name].isValid;
    const { errorMessage } = fieldValidation[name] || {};
    const { label: textLabel } = accessibility;
    return (
      isFieldVisible && (
        <div
          className='td-slider-wrapper-web-sdk'
          data-testid='slider-wrapper'
          ref={this.wrapperRef}
        >
          <Label
            name={name}
            text={title}
            isRequired={this.isRequired}
            params={params}
            invalid={invalid}
            appData={appData}
            srLabel={textLabel}
          />
          <ThemeSlider
            handleChange={(fieldItem, option) => {
              resetFieldValidation(name);
              handleSliderChange(fieldItem, option);
            }}
            field={{ value: values[name], ...field }}
            components={this.props.components}
            invalid={invalid}
            isRadioGroup
            label={title}
          />
          <ValidationMessage isInvalid={invalid}>
            {errorMessage}
          </ValidationMessage>
        </div>
      )
    );
  }
}

Slider.propTypes = fieldPropTypes;

export default Slider;
